<div class="container">
  <div class="row d-flex justify-content-center">
    <div class="col-md-12 text-center main-title">
      <h1>Update daily</h1>
    </div>
  </div>
  <div class="datatable mt-4">
    <table class="table datatable-table" mdbTable mdbTableSort #table="mdbTable" #sort="mdbTableSort"
      [dataSource]="tableData" [sort]="sort">
      <thead class="datatable-header">
        <tr>
          <th *ngFor="let header of headers" [mdbTableSortHeader]="header" scope="col">
            {{ header | titlecase }}
          </th>
        </tr>
      </thead>
      <tbody class="datatable-body">

        <tr>
          <td></td>
          <td>
            <span class="m-3" *ngIf="loading1">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </span>
            <button class="btn btn-primary" (click)="aggiornaDb()">Aggiorna BF</button>
          </td>
          <td>
            
            <span class="m-3" *ngIf="loading2">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </span>
            <button class="btn btn-primary" (click)="aggiornaDbang()">Aggiorna dbang</button>
          </td>
          <td>
            <span class="m-3" *ngIf="loading3">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </span>
            <button class="btn btn-primary" (click)="aggiornaDbangRawal()">Aggiorna rawal</button>
          </td>
          <td>
            <span class="m-3" *ngIf="loading4">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </span>
            <button class="btn btn-primary" (click)="aggiornaDbangRawalBT()">Aggiorna rawal_bt</button>
          </td>
        </tr>
        <tr *ngFor="let data of table.data" scope="row">
          <td>{{data.market}}</td>
          <td [ngClass]="data.newBF ? 'green' : 'standard'">{{data.lastbf}}</td>
          <td [ngClass]="data.newBang2 ? 'green' : 'standard'">{{data.lastora}}</td>
          <td [ngClass]="data.newRawal ? 'green' : 'standard'">{{data.lastrawal}}</td>
          <td [ngClass]="data.newRawalBT  ? 'green' : 'standard'">{{data.lastbt}}</td>
        </tr>
      </tbody>
    </table>

  </div>